import React from 'react'
import { SideInfo } from 'src/Pages/Auth/Side-info'
import { Wrapper } from './style'
import { LoginForm } from './Form'
import SEO from 'src/seo'
const Login = () => {
  return (
    <Wrapper>
      <SEO title="Login" />
      <SideInfo children="Log In" />
      <LoginForm />
    </Wrapper>
  )
}

export { Login }
